import React from 'react';
import FormInput from '../atoms/FormInput';

/**
 * ContactForm - Formulario de datos de contacto
 *
 * Props:
 * - email: Valor actual del email
 * - confirmEmail: Valor actual de confirmación de email
 * - phone: Valor actual del teléfono
 * - onChange: Función callback (fieldName, value) => void
 * - errors: Objeto con errores { email, confirmEmail, phone }
 * - className: Clases CSS adicionales (opcional)
 */
function ContactForm({
  email = '',
  confirmEmail = '',
  phone = '',
  onChange,
  errors = {},
  className = ''
}) {
  const handleChange = (fieldName) => (e) => {
    onChange(fieldName, e.target.value);
  };

  return (
    <div className={`d-flex flex-column gap-3 px-2 ${className}`}>
      {/* Email */}
      <FormInput
        label="Email"
        type="email"
        required
        placeholder="ejemplo@correo.com"
        value={email}
        onChange={handleChange('email')}
        error={errors.email}
      />

      {/* Confirm Email */}
      <FormInput
        label="Confirmar Email"
        type="email"
        required
        placeholder="ejemplo@correo.com"
        value={confirmEmail}
        onChange={handleChange('confirmEmail')}
        error={errors.confirmEmail}
      />

      {/* Phone */}
      <FormInput
        label="Teléfono"
        type="tel"
        required
        placeholder="+57 300 123 4567"
        value={phone}
        onChange={handleChange('phone')}
        error={errors.phone}
        pattern="^\+\d{1,4}\s?\d{6,14}$"
        title="Formato: +[código país] número (ej: +57 300 123 4567)"
      />
    </div>
  );
}

export default ContactForm;
